import React, { useState } from "react";
import WithdrawalData from "../UserDetails/WithdrawalData";
// import TransactionData from "../TransactionHistory/TransactionData";
// import Moment from "moment";
import DepositData from "../UserDetails/DepositData";
// import axios from "axios";
// import { UseDepositHistoryDetailsData, UseWithdrawalHistoryDetailsData } from "../Utils/TransactionData";
import TransactionHistoryData from "../TransactionHistory/TransactionHistotyData";

const TransferMain = () => {
  // const [deposit, setDeposit] = useState();
  // const [withdrawal, setWithdrawal] = useState();
  // const { data: depositDataHistoryDetails } = UseDepositHistoryDetailsData();
    // const { data: withdrawalDataHistoryDetails } = UseWithdrawalHistoryDetailsData();

  // const getDepositedData = () => {
  //   axios
  //     .get(
  //       "https://new-dashboard.server.sypto.xyz/api/user/deposit/dashboard/history"
  //     )
  //     .then((res) => {
  //       setDeposit(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // const getWithdrawalData = () => {
  //   axios
  //     .get(
  //       "https://new-dashboard.server.sypto.xyz/api/user/withdrawal/dashboard/history"
  //     )
  //     .then((res) => {
  //       setWithdrawal(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // useEffect(() => {
  //   getDepositedData();
  //   getWithdrawalData();
  // }, []);

  // const depositData = depositDataHistoryDetails && depositDataHistoryDetails.data.values;

  // const withdrawalData = withdrawalDataHistoryDetails && withdrawalDataHistoryDetails.data.values;
  const [filterData, setFilterData] = useState("withdrawal");
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");

  // const saved = localStorage.getItem("userDetails");
  // const initialValue = JSON.parse(saved);
  // const userDetails = initialValue && initialValue.response;

  // const filteredTradesFromDate = (Data) => {
  //   const value = Data.filter((result) => {
  //     const item = new Date(result[7]);
  //     const start = Moment(String(item)).format("YYYY-MM-DD") >= startDate;
  //     return start;
  //   });
  //   const sortedTradeHistory =
  //     value && value.slice().sort((a, b) => new Date(b[7]) - new Date(a[7]));
  //   return sortedTradeHistory;
  // };

  // const filteredTradesFromEndDate = (Data) => {
  //   const value = Data.filter((result) => {
  //     const item = new Date(result[7]);
  //     const end = Moment(String(item)).format("YYYY-MM-DD") <= endDate;
  //     return end;
  //   });
  //   const sortedTradeHistory =
  //     value && value.slice().sort((a, b) => new Date(b[7]) - new Date(a[7]));
  //   return sortedTradeHistory;
  // };

  // const filteredTradesFromStartToEndDate = (Data) => {
  //   const value = Data.filter((result) => {
  //     const item = new Date(result[7]);
  //     const start = Moment(String(item)).format("YYYY-MM-DD") >= startDate;
  //     const end = Moment(String(item)).format("YYYY-MM-DD") <= endDate;
  //     const data = start && end;
  //     return data;
  //   });
  //   const sortedTradeHistory =
  //     value && value.slice().sort((a, b) => new Date(b[7]) - new Date(a[7]));
  //   return sortedTradeHistory;
  // };

  // const filterAndSorted = (rawData) => {
  //   var raw = rawData;
  //   // console.log("raq", raw[0][7]);
  //   const sortedTradeHistory =
  //     raw && raw.slice().sort((a, b) => new Date(b[7]) - new Date(a[7]));
  //   var sortedData = [];
  //   if (startDate) {
  //     sortedData = filteredTradesFromDate(raw);
  //   }
  //   if (endDate) {
  //     sortedData = filteredTradesFromEndDate(raw);
  //   }
  //   if (startDate && endDate) {
  //     sortedData = filteredTradesFromStartToEndDate(raw);
  //   }
  //   sortedData =
  //     startDate && endDate
  //       ? sortedData
  //       : sortedData.length === 0
  //       ? sortedTradeHistory
  //       : sortedData;

  //   return sortedData;
  // };
  return (
    <div className="mt-20 px-4 md:px-4">
      <div className="relative w-full pt-10 pb-2 md:pt-10 md:pb-2 lg:pt-12 lg:pb-8 z-10">
        {/* 
      <div className="absolute -top-[560px] -left-[180px] z-0  blur-box w-[460px] h-[560px] md:w-[760px] md:h-[760px] rounded-full  filter blur-2xl opacity-90 "></div>
        */}
        <div className="bg-gradient-to-tl from-[#FEF35A99]/90 via-[#FFFFFF]/40 to-[#FEF35A99]/10 p-[1px] rounded-[12px] md:rounded-[12px]">
        <div className="relative border-[1px] border-[#ffffff]/10 rounded-[12px] md:rounded-[12px] shadow-custom-inner-high backdrop-blur-custom bg-black shadow-lg p-6">
          <div className="absolute flex flex-row items-center -top-[5%] lg:-top-[18%] p-2 lg:p-4 bg-gradient-to-r from-[#000000] to-[#000000] rounded-[12px] shadow-lg lg:ml-2">
            <label className="text-2xl font-semibold text-white font-poppins cursor-pointer mb-2 md:mb-0">
              <input
                type="radio"
                value="withdrawal"
                checked={filterData === "withdrawal"}
                onChange={() => setFilterData("withdrawal")}
                className="mr-2"
                style={{
                  accentColor: filterData === "withdrawal" ? "yellow" : "transparent"
                }}
              />
              Withdrawal
            </label>
            <div className="px-6 text-[#ffffff]/30 hidden md:block"></div>
            <label className="text-2xl font-semibold text-white font-poppins cursor-pointer mb-2 md:mb-0 ml-2">
              <input
                type="radio"
                value="deposit"
                checked={filterData === "deposit"}
                onChange={() => setFilterData("deposit")}
                className="mr-2"
                style={{
                  accentColor: filterData === "deposit" ? "yellow" : "transparent"
                }}
              />
              Deposit
            </label>
          </div>
          {/* <div className="mt-2 text-xs md:text-sm text-[#ffffff]/50 font-light font-poppins">
            Whitelist your Wallet Address for Quick Withdrawals from your
            Dashboard.
          </div> */}
          <div className="mb-4">
            {filterData === "withdrawal" ? (
              <WithdrawalData />
            ) : (
              <DepositData />
            )}
          </div>
        </div>
        </div>
        {/* <div className="mt-6 flex  flex-row justify-between items-center text-center">
          <div
            className={`text-[16px] md:text-[20px] lg:text-[22px] text-white font-semibold font-montserrat`}
          >
            Transaction History
          </div>
        </div>
        {filterData === "withdrawal" ? (
          <TransactionData
            tradeData={filterAndSorted(withdrawalData && withdrawalData)}
            // userDetails={userDetails && userDetails}
            // filterData={filterData}
            // getWithdrawalData={getWithdrawalData}
          />
        ) : (
          <TransactionData
            tradeData={filterAndSorted(depositData && depositData)}
            // userDetails={userDetails && userDetails}
            // filterData={filterData}
            // getDepositedData={getDepositedData}
          />
        )} */}
        <TransactionHistoryData />
      </div>
    </div>
  );
};

export default TransferMain;
